import {EventTotalGuests} from '@wix/ambassador-events-ui-v1-widget-data/types'
import {State} from '../types/state'

export const getEventTotalGuests = (state: State, eventId: string): EventTotalGuests | undefined =>
  state.totalGuests?.totalGuests?.[eventId]

export const getEventAttendingGuests = (state: State, eventId: string): number | undefined =>
  getEventTotalGuests(state, eventId)?.attending ?? 0
